import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import api from '../../../../../../services/api';
import utils from '../../../../../../services/utils';

import './AuthenticationStep.css';

class AuthenticationStep extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            errorMessage: ''
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    }

    submitForm() {
        // Ensure email is valid
        let validEmail = utils.validateEmail(this.state.email);
        if (!validEmail) {
            this.setState({
                errorMessage: `Please enter a valid email.`
            });
            return;
        }

        api.submitPassword(this.state.password)
        .then((res) => {
            let response = res.data;

            if (response.success) {
                this.props.beginOnboarding(this.state.email);
            } else {
                this.setState({
                    errorMessage: `That doesn't seem right.`
                });
            }
        });
    }

    render() {
        return (
            <div className="authentication-step outer-authentication">
                <div className="middle-authentication">
                    <div className="inner-authentication">
                        <div className="authentication-step-text">
                            <hr />
                            <p className="authentication-step-header"> Please enter your Veles password to continue.</p>
                            <p className="authentication-step-header">You can request a password <Link className="noselect" to='/request'>here</Link>.</p>
                        </div>

                        <div className="password-form-div">
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    onChange={(event) => this.handleUserInput(event)}
                                    name="email"
                                    value={this.state.email}
                                    className="authentication-step-input"
                                    type="text"
                                    placeholder="Email"
                                />
                                <input
                                    onChange={(event) => this.handleUserInput(event)}
                                    name="password"
                                    value={this.state.password}
                                    className="authentication-step-input auth-step-password"
                                    type="password"
                                    placeholder="Password"
                                />

                                <button onClick={this.submitForm} className="authentication-step-submit-btn">
                                    <i className="ion ion-android-arrow-forward" />
                                </button>
                            </form>
                        </div>

                        <p className={"auth-err form-error" + (this.state.errorMessage.length > 0 ? '' : ' hidden-error')}>
                            {this.state.errorMessage}
                        </p>
                    </div>
                </div>
            </div>
        );
    };
}

export default AuthenticationStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/AuthenticationStep/AuthenticationStep.js